import React from 'react';
import PropTypes from 'prop-types';
import {Formik, Form, Field} from 'formik';
/* Components */
import Modal from '../../common/modal/modal';
import RadioButton from '../../common/form-elements/radio-button/radio-button';
import Checkbox from '../../common/form-elements/checkbox/checkbox';
import {isAuthorizedAction} from '../../../helpers/dashboard-helpers';

class DashboardPermissionsSettingsModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedPermissionSettingsId: this.props.selectedPermissionSettingsId,
      isShared: this.props.isShared,
    };
  }

  handleSave = (values) => {
    this.props.onSave(values.selectedPermissionSettingsId);
    this.props.onSaveShared(values.isShared);
    this.props.onClose();
  };

  closeAndDiscard = () => {
    this.props.onClose();
  };

  render() {
    return (
      <Modal.Default isOpen={this.props.isOpen}>
        <Formik
          initialValues={{
            selectedPermissionSettingsId: this.state.selectedPermissionSettingsId,
            isShared: this.state.isShared,
          }}
          onSubmit={this.handleSave}
        >
          {(props) => {
            return (
              <Form>
                <div className="glu-modal__header glu-flex glu-flex-align-center">
                  <div className="glu-modal__title glu-flex-grow">Permission settings</div>
                  <div className="glu-flex-shrink">
                    <button
                      aria-label="close"
                      type="button"
                      className="glu-btn-link g-icon g-icon-close"
                      onClick={this.closeAndDiscard}
                    />
                  </div>
                </div>
                <div className="glu-modal__body">
                  <div className="glu-content__section">
                    {isAuthorizedAction('publicDashboardWrite') &&
                      this.props.permissionSettingsOptions.map((option) => (
                        <div className="glu-form-row" key={option.id}>
                          <Field
                            as={RadioButton}
                            name="selectedPermissionSettingsId"
                            value={option.id}
                            onChange={props.handleChange}
                            isChecked={
                              option.id === Number(props.values.selectedPermissionSettingsId)
                            }
                          >
                            <div className="glu-radio__permission-title">{option.title}</div>
                            <p className="glu-radio__permission-info text-secondary">
                              {option.description ? option.description : null}
                            </p>
                          </Field>
                        </div>
                      ))}
                    <div className="glu-form-row">
                      <Field
                        as={Checkbox}
                        name="isShared"
                        className="glu-checkbox__permission"
                        onChange={props.handleChange}
                        isChecked={props.values.isShared}
                      >
                        <div className="glu-radio__permission-title">
                          Make this dashboard also available in child organizations.
                        </div>
                      </Field>
                    </div>
                  </div>
                </div>
                <footer className="glu-modal__footer">
                  <div className="glu-flex-grow glu-flex-row">
                    <div className="glu-flex-grow text-right">
                      <button
                        type="button"
                        onClick={this.closeAndDiscard}
                        className="glu-btn glu-btn--secondary"
                      >
                        Cancel
                      </button>
                    </div>
                    <div className="glu-flex-shrink">
                      <button className="glu-btn glu-btn--primary" type="submit">
                        Save
                      </button>
                    </div>
                  </div>
                </footer>
              </Form>
            );
          }}
        </Formik>
      </Modal.Default>
    );
  }
}

DashboardPermissionsSettingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isShared: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onSaveShared: PropTypes.func.isRequired,
  permissionSettingsOptions: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  selectedPermissionSettingsId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default DashboardPermissionsSettingsModal;
